module.exports = __webpack_public_path__ + "static/media/caetsu.c49f79ef.webp";